import { styled } from '@mui/system'
import { colors, fontSizes } from '../../Components/consts'

export const QuestionSection = styled('div')(
  ({ theme }) => ({
   minHeight: '90vh',
   '& .groupTitle': {
    textAlign: 'center',
    fontSize: fontSizes.xlarge,
    fontWeight: 'bold',
    margin: theme.spacing(4, 2, 8),
    color: colors.text,
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.semiLarge,
    },
   },
   '& .qCon': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    marginTop: theme.spacing(2),
  }
  })
)

export const QuestionCon = styled('div')(
  ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: theme.spacing(2, 0)
  })
)